import { getContext } from "svelte";
import type { SharedGlobalSettings } from "./SharedGlobalSettings.js";
import { sharedGlobalSettingsContextKey } from "./SharedGlobalSettings.js";

export function getSharedGlobalSettings(): SharedGlobalSettings {
	return getContext<SharedGlobalSettings>(sharedGlobalSettingsContextKey);
}
